import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import Icon from '../../../../../../src/components/lib/Icon';
import lockIcon from '../../../../../../static/images/menu-icons/LockedLockBLACK.svg';

const setLockIconRightMarginAndReturnLockStyle = {
  width: '16px',
  height: '16px',
  top: '10px',
  right: '13px',
  margin: 0,
};

const FSMenuItem = (props) => {
  const {
    leftIcon,
    linkTo,
    onClick,
    onClickTab,
    onClickTerm,
    primaryText,
    showLock,
    openTabHandler,
    menuItemClickHandler,
  } = props;

  const rightLock = showLock ? (
    <Icon
      src={lockIcon}
      style={setLockIconRightMarginAndReturnLockStyle}
    />
  ) : null;

  const onClickAction = onClick || (
    onClickTab ?
      openTabHandler(linkTo, onClickTerm) : menuItemClickHandler(linkTo, onClickTerm)
  );

  return (
    <MenuItem
      className='menu-item'
      style={{ backgroundColor: 'transparent',
      lineHeight: '9px',
      minHeight: 0,
      height: '34px',
    }}
      innerDivStyle={{
        color: 'black',
        backgroundColor: 'transparent',
        padding: 0,
      }}
      primaryText={primaryText}
      containerElement={
      linkTo.includes('http') ?
        /* eslint-disable jsx-a11y/anchor-has-content */
        <a
          href={linkTo}
          title={primaryText}
          onClick={e => e.preventDefault()}
        /> :
        <div />
        /* eslint-enable jsx-a11y/anchor-has-content */
      }
      leftIcon={
        leftIcon ?
          <Icon
            src={leftIcon}
            style={{
              marginTop: '8px',
              marginLeft: '15px',
              width: '30px',
              height: '30px',
            }}
          /> :
          null
      }
      rightIcon={rightLock}
      onClick={onClickAction}
    />
  );
};

FSMenuItem.propTypes = {
  leftIcon: PropTypes.string,
  linkTo: PropTypes.string,
  menuItemClickHandler: PropTypes.func,
  onClick: PropTypes.func,
  onClickTab: PropTypes.bool,
  onClickTerm: PropTypes.string,
  openTabHandler: PropTypes.func,
  primaryText: PropTypes.string,
  showLock: PropTypes.bool,
};

export default FSMenuItem;



// WEBPACK FOOTER //
// ./modules/App/components/children/Header/children/FSMenuItem.js